// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum Origin {
  Unmapped = 0,
  Profile = 1,
  Override = 2,
  ProfileOnly = 3,
}
